import { useMutation } from 'react-query';
import { authFetch } from '../../../CommonUtils/authFetch';
import { urlWithParams } from '../../../CommonUtils/urlWithParams';
import { DraftAccountDTO } from '../AccountOpening.meta';

interface OpenDraftAccountParams {
  clientId: string;
  isFromWorkflow: boolean;
}

const openDraftAccount = ({
  clientId,
  isFromWorkflow,
}: OpenDraftAccountParams): Promise<{ data: DraftAccountDTO }> => {
  return authFetch(
    urlWithParams('/Consumer/ManagedAccounts/AccountOpeningDraft', {
      clientId,
      forAutomatedAccountWorkflow: isFromWorkflow,
    }),
  );
};

export const useOpenDraftMutation = () => {
  return useMutation(openDraftAccount);
};
